// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__1NDzL","item":"PaymentsMobile_item__216Ae","label":"PaymentsMobile_label__LCCsp","amount":"PaymentsMobile_amount__cnwgR"};